/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A3Inputs */

const en_pc_faq_a3 = /** @type {(inputs: Pc_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. PDFCraftTool.org is an independent, third-party guide and is not run by ArtCraft. PdfCraft is developed by the ArtCraft team, and its source code and releases are at github.com/storytold/pdfcraft. Every download button here links to the files ArtCraft publishes there, so you get the same signed builds.`)
};

const zh_pc_faq_a3 = /** @type {(inputs: Pc_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。PDFCraftTool.org 是独立的第三方指南站，并非由 ArtCraft 运营。PdfCraft 由 ArtCraft 团队开发，源代码与发布文件位于 github.com/storytold/pdfcraft。本站的每个下载按钮都链接到 ArtCraft 在那里发布的文件，所以你拿到的是同样经过签名的构建。`)
};

/**
* | output |
* | --- |
* | "No. PDFCraftTool.org is an independent, third-party guide and is not run by ArtCraft. PdfCraft is developed by the ArtCraft team, and its source code and rel..." |
*
* @param {Pc_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a3 = /** @type {((inputs?: Pc_Faq_A3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a3(inputs)
	return zh_pc_faq_a3(inputs)
});
export { pc_faq_a3 as "pc.faq.a3" }